// if negative dpr, it'll negate it and use it always
// if positive dpr, it'll use it if no window present, otherwise it will use window.devicePixelRatio
export default function twicpicsSource (src, width, height, dpr = 1, rect) {
  let rectComponents
  const finalDpr = dpr < 0 ? -dpr : (typeof window !== 'undefined' ? window.devicePixelRatio || dpr : dpr) || 1

  if (src && src.indexOf('data:image/') === 0) {
    return src
  }

  if (!src || src.indexOf('https://www.apprentus.com/assets/design/default_avatar.png') === 0) {
    return 'https://www.apprentus.com/assets/design/default_avatar.png'
  }

  if (rect) {
    rectComponents = rect.split(',')
    const x = rectComponents[0]
    const y = rectComponents[1]
    const w = rectComponents[2]
    const h = rectComponents[3]
    return `${src}?twic=v1/crop=${w}x${h}@${x}x${y}/from=1`
  }

  return `${src}?twic=v1/focus=auto/cover=${width * finalDpr}x${(height || width) * finalDpr}/from=1`
}
